import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/user.service';
import { SystemUser } from '../system-user';
import { Booking } from '../booking';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FaviconService } from '../favicon.service';
import { forkJoin, Observable } from 'rxjs';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DownloadType } from '../download-type';
import { SearchAction } from '../search-action';
import { SearchOperator } from '../search-operator';
import { SearchColumn } from '../search-column';
import { SearchRule } from '../search-rule';
import * as moment from 'moment';
import { SavedSearch } from '../saved-search';
import { LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { BOOKINGEXPORTOPTIONS } from '../csv-export-config';
import { CustomCsvExportConfiguration } from '../custom-csv-export-configuration';
import { RelateveDate } from '../relative-date';
import { SearchDataType } from '../search-data-type';
import { ToastMessageService } from '../toast-message.service';
import { SalesProductType } from '../sales-product-type';
import { ProgrammeType } from '../programme-type';
import { SimpleBooking } from '../simple-booking';
import { BookingsSearchService } from '../service/bookings-search.service';
import { SchoolListItem } from '../school-list-item';
import { Country } from '../country';
import { Language } from '../language';
import { AccommodationType } from '../accommodation-type';
import { RoomType } from '../room-type';
import { BoardType } from '../board-type';
import Decimal from 'decimal.js';
import { ApiError } from '../api-error';
import { UserForBackend } from '../user-for-backend';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.css']
})
export class BookingsComponent implements OnInit {

  user!: SystemUser;

  pageRecordsOptions = [50, 100, 500];
  months: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  years: number[] = [];

  pdfUrl!: string;
  downloading!: boolean;
  reportDownloadUrl!: SafeResourceUrl;
  searchTerm!: string;
  first: number = 0;
  searchForm!: FormGroup;
  filter!: Observable<string>;
  customSearchForm!: FormGroup;
  searchOperators: SearchOperator[] = [];
  dateSearchOperators: SearchOperator[] = [];
  searchActions: SearchAction[] = [];
  searchColumns: SearchColumn[] = [];
  exportingXlsx = false;
  xlsxDownloadIcon = "pi pi-download";
  exportingCsv = false;
  csvDownloadIcon = "pi pi-download";

  exportingMonthlyXlsx = false;
  monthlyXlsxDownloadIcon = "pi pi-download";

  dateOffsetOptions: SelectItem[] = [
    { label: "", value: null },
    { label: "+", value: "+" },
    { label: "-", value: "-" }
  ];
  booleanValues: SelectItem[] = [
    { label: "Is true", value: true },
    { label: "Is false", value: false }
  ];
  listElementOperators: SearchOperator[] = [
    new SearchOperator(1, "=", "is")
  ];

  oldSearchColumn: SearchColumn | null = null;

  yearRange: string = moment().subtract(80, "years").year() + ":" + moment().add(5, "years").year();

  navigationItems: MenuItem[] = [];
  activeItemId = 1;
  activeItem!: MenuItem;
  monthlyReportForm: FormGroup;

  selectedExportOptions = [];
  exportOptions = BOOKINGEXPORTOPTIONS;
  hasInvalidInput = false;
  salesProductTypes: SalesProductType[] = [];
  programmeTypes: ProgrammeType[] = [];
  schools: SchoolListItem[] = [];
  countries: Country[] = [];
  languages: Language[] = [];
  accommodationTypes: AccommodationType[] = [];
  roomTypes: RoomType[] = [];
  boardTypes: BoardType[] = [];
  searchPerformance: number | null = null;
  idSortMode = -1;
  startDateSortMode = -1;
  endDateSortMode = -1;
  durationSortMode = -1;
  schoolSortMode = -1;
  courseSortMode = -1;
  firstNameSortMode = -1;
  lastNameSortMode = -1;
  activeSortMode = -1;
  dueAmountSortMode = -1;
  languageSortMode = -1;
  totalReceivedSortMode = -1;



  lastYear = moment().year() - 1;
  productToReportLabel = "Product to report " + this.lastYear + "-" + (this.lastYear + 1);

  counsellors: UserForBackend[] = [];
  isFirstLoad = true;

  constructor(
    private userService: UserService,
    private httpService: HttpService,
    private loginService: LoginService,
    private favicon: FaviconService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    public bookingSearchService: BookingsSearchService
  ) {
    this.years
    let thisYear = moment().year();
    for (let i = 2022; i <= thisYear; i++) {
      this.years.push(i);
    }
    let thisMonth = moment().month() + 1;
    this.loginService.activatedNavigationComponent = true;
    this.monthlyReportForm = builder.group({
      year: thisYear,
      month: [thisMonth, Validators.required]
    }
    );
    this.favicon.sbms();
  }

  ngOnInit(): void {
    this.bookingSearchService.getFavoriteSearches();
    this.httpService.getSalesProductTypes().subscribe(res => this.salesProductTypes = res);
    this.httpService.getAllProgrammeTypes().subscribe(res => this.programmeTypes = res);
    this.httpService.getSchools().subscribe(res => this.schools = res);
    this.httpService.getAllCountries().subscribe(res => this.countries = res);
    this.httpService.getLanguages().subscribe(res => this.languages = res);
    this.httpService.getAccommodationTypes().subscribe(res => this.accommodationTypes = res);
    this.httpService.getRoomTypes().subscribe(res => this.roomTypes = res);
    this.httpService.getBoardTypes().subscribe(res => this.boardTypes = res);
    this.httpService.getCounsellors().subscribe(res => this.counsellors = res);
    this.user = new SystemUser(this.userService.userName, this.userService.roles!);
    this.httpService.getSearchActions().subscribe(res => {
      this.searchActions = res;
      this.customSearchForm.get("action")!.setValue(this.searchActions[0]);
    });
    this.httpService.getSearchColumns().subscribe(res => {
      this.searchColumns = res;
      let defaultColumn = res.find(column => column.id == 3);
      this.customSearchForm.get("column")!.setValue(defaultColumn);
      this.oldSearchColumn = defaultColumn!;
    });
    this.httpService.getSearchOperators().subscribe(res => {
      this.searchOperators = res;
      //Remove search operator 'contains' for date value. not useful at all.
      this.dateSearchOperators = res.filter(val => {
        return val.id != 5;
      });
      let defaultOperator = res.find(operator => operator.id == 5);
      //Remove search operator 'is null' and 'is not null' for normal search operators.
      this.searchOperators.pop();
      this.searchOperators.pop();
      this.customSearchForm.get("operator")!.setValue(defaultOperator);
    });
    this.initNavigationTabs();
    this.searchForm = this.builder.group({
      searchTerm: ""
    });
    this.bookingSearchService.savedSearchForm = this.builder.group({
      name: [null, Validators.required],
      isPublic: [false, Validators.required]
    });
    this.customSearchForm = this.builder.group({
      action: null,
      column: null,
      operator: null,
      value: null,
      dateOffsetOption: this.dateOffsetOptions[0],
      isRelativeDate: false,
      dateOffset: null
    });
    if (this.bookingSearchService.bookings.length == 0) {
      this.getAllBookings();
    }
  }

  getAllBookings() {
    if (!this.isFirstLoad) {
      this.bookingSearchService.loading = true;
    }
    forkJoin({
      bookings: this.httpService.getAllBookingsByPage(100, 0),
      recordNumber: this.httpService.getAllBookingsNumber()
    }).subscribe(({ bookings, recordNumber }) => {
      this.handleBookingCourseNullValue(bookings);
      this.bookingSearchService.loading = false;
      this.bookingSearchService.bookings = bookings;
      this.bookingSearchService.recordNumber = recordNumber;
    }, error => {
      this.bookingSearchService.loading = false;
      this.toastService.addError("Error", error.error.message);
    });
  }

  handleBookingCourseNullValue(bookings: SimpleBooking[]) {
    for (let booking of bookings) {
      if (booking.course == null) {
        booking.course = "";
      }
    }
  }

  lazyLoad(event: TableLazyLoadEvent) {
    this.bookingSearchService.recordsByPage = event.rows!;
    if (!this.isFirstLoad) {
      this.bookingSearchService.loading = true;
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    if (this.bookingSearchService.searchRules.length == 0) {
      forkJoin({
        bookings: this.httpService.getAllBookingsByPage(this.bookingSearchService.recordsByPage, event.first!),
        recordNumber: this.httpService.getAllBookingsNumber()
      }).subscribe(({ bookings, recordNumber }) => {
        this.handleBookingCourseNullValue(bookings);
        this.bookingSearchService.loading = false;
        this.bookingSearchService.bookings = bookings;
        this.bookingSearchService.recordNumber = recordNumber;
        this.isFirstLoad = false;
      }, error => {
        this.bookingSearchService.loading = false;
        this.toastService.addError("Error", error.error.message);
        this.isFirstLoad = false;
      });
    } else {
      forkJoin({
        bookings: this.httpService.getBookingsCustom(this.bookingSearchService.searchRules, this.bookingSearchService.recordsByPage, event.first!),
        recordNumber: this.httpService.getBookingsCustomRecordNumber(this.bookingSearchService.searchRules)
      }).subscribe(({ bookings, recordNumber }) => {
        this.handleBookingCourseNullValue(bookings);
        this.bookingSearchService.loading = false;
        this.bookingSearchService.bookings = bookings;
        this.bookingSearchService.recordNumber = recordNumber;
        this.isFirstLoad = false;
      }, error => {
        this.bookingSearchService.loading = false;
        this.toastService.addError("Error", error.error.message);
        this.isFirstLoad = false;
      });
    }
  }

  initNavigationTabs() {
    this.navigationItems = [
      { id: "1", label: "Search Bookings", command: () => this.activeItemId = 1 },
      { id: "3", label: "Easy Search", command: () => this.activeItemId = 3 },
      { id: "2", label: "Export", command: () => this.activeItemId = 2 }
    ];
    this.activeItem = this.navigationItems[0];
  }

  searchColumnChange() {
    this.setSearchFormDefaultOperator();
    this.setSearchFormDefaultValue();
    this.oldSearchColumn = this.customSearchForm.value.column;
  }

  setSearchFormDefaultValue() {
    if (this.customSearchForm.value.column.searchDataType.name == "boolean") {
      this.customSearchForm.get("value")!.setValue(true);
    } else if (
      !(this.oldSearchColumn!.name === "first_name" && this.customSearchForm.value.column.name === "last_name" || this.oldSearchColumn!.name === "last_name" && this.customSearchForm.value.column.name === "first_name")
    ) {
      this.customSearchForm.get("value")!.reset();
    }
  }

  setSearchFormDefaultOperator() {
    let defaultOperator = null;
    switch (this.customSearchForm.value.column.searchDataType.name) {
      case "long":
      case "duration":
      case "age":
      case "remainingBalance":
      case "totalSchoolInvoice":
      case "totalAmount":
        defaultOperator = this.searchOperators[0];
        break;
      case "string":
        let defaultOperatorIndex = 0;
        //If selected column is first name or last name, set default operator to "Contains"
        if (this.customSearchForm.value.column.name == "first_name" || this.customSearchForm.value.column.name == "last_name") {
          defaultOperatorIndex = 4;
        }
        defaultOperator = this.searchOperators[defaultOperatorIndex];
        break;
      case "date":
        defaultOperator = this.searchOperators[0];
        break;
      case "boolean":
        defaultOperator = null;
        break;
      case "listElement":
        defaultOperator = this.listElementOperators[0];
        break;
    }
    this.customSearchForm.get("operator")!.setValue(defaultOperator);
  }

  clearAllSearches() {
    this.resetSerchPerformance();
    this.bookingSearchService.clearSearchRules();
    this.getAllBookings();
  }

  removeRule(index: number) {
    this.resetSerchPerformance();
    this.bookingSearchService.searchRules.splice(index, 1);
    this.bookingSearchService.loading = true;
    if (this.bookingSearchService.searchRules.length == 0) {
      forkJoin({
        bookings: this.httpService.getAllBookingsByPage(this.bookingSearchService.recordsByPage, 0),
        recordNumber: this.httpService.getAllBookingsNumber()
      }).subscribe(({ bookings, recordNumber }) => {
        this.bookingSearchService.loading = false;
        this.bookingSearchService.bookings = bookings;
        this.bookingSearchService.recordNumber = recordNumber;
      }, error => {
        this.bookingSearchService.loading = false;
        this.toastService.addError("Error", error.message);
      });
    } else {
      forkJoin({
        bookings: this.httpService.getBookingsCustom(this.bookingSearchService.searchRules, this.bookingSearchService.recordsByPage, 0),
        recordNumber: this.httpService.getBookingsCustomRecordNumber(this.bookingSearchService.searchRules)
      }).subscribe(({ bookings, recordNumber }) => {
        this.bookingSearchService.loading = false;
        this.bookingSearchService.bookings = bookings;
        this.bookingSearchService.recordNumber = recordNumber;
      }, error => {
        this.bookingSearchService.loading = false;
        let apiError = new ApiError(error);
        this.toastService.addError("Error", apiError.message);
      });
    }
  }

  customSearch() {
    this.hasInvalidInput = false;
    if (this.customSearchForm.invalid) {
      return;
    }
    this.searchPerformance = null;
    let startMoment = moment();
    let searchRule = null;
    //handle date input like departure, return
    if (this.customSearchForm.value.column.searchDataType.name == "date") {
      //if 'is null'
      if (this.customSearchForm.value.operator.name == "is null") {
        searchRule = new SearchRule(
          this.customSearchForm.value.action,
          this.customSearchForm.value.operator,
          this.customSearchForm.value.column,
          new SearchDataType(9, "null")
        );
      } else if (this.customSearchForm.value.operator.name == "is not null") {
        searchRule = new SearchRule(
          this.customSearchForm.value.action,
          this.customSearchForm.value.operator,
          this.customSearchForm.value.column,
          new SearchDataType(10, "not null")
        );
      }

      else if (this.customSearchForm.value.isRelativeDate) {
        //if 'today'
        let offset = this.customSearchForm.value.dateOffset;
        if (this.customSearchForm.get("dateOffsetOption")!.value.value == "-") {
          offset *= -1;
        }
        searchRule = new SearchRule(
          this.customSearchForm.value.action,
          this.customSearchForm.value.operator,
          this.customSearchForm.value.column,
          new SearchDataType(4, "today"),
          null,
          null,
          null,
          null,
          new RelateveDate(offset)
        );
        //if normal date
      } else {
        if (!this.customSearchForm.value.value) {
          this.toastService.addError("Error", "Please select a date");
          return;
        }
        let date = moment(this.customSearchForm.value.value);
        if (!date.isValid()) {
          this.toastService.addError("Error", "Invalid date");
          return;
        }
        searchRule = new SearchRule(
          this.customSearchForm.value.action,
          this.customSearchForm.value.operator,
          this.customSearchForm.value.column,
          this.customSearchForm.value.column.searchDataType,
          null,
          null,
          moment(this.customSearchForm.value.value).utc(true)
        );
      }
      // handle string input like name, city
    } else if (this.customSearchForm.value.column.searchDataType.name == "string") {
      if (!this.customSearchForm.value.value) {
        this.toastService.addError("Error", "You need to enter a value");
        return;
      }
      searchRule = new SearchRule(
        this.customSearchForm.value.action,
        this.customSearchForm.value.operator,
        this.customSearchForm.value.column,
        this.customSearchForm.value.column.searchDataType,
        this.customSearchForm.value.value
      );
      //handle number input like id, amount
    } else if (this.customSearchForm.value.column.searchDataType.name == "long" || this.customSearchForm.value.column.searchDataType.name == "totalAmount"
      || this.customSearchForm.value.column.searchDataType.name == "totalSchoolInvoice" || this.customSearchForm.value.column.searchDataType.name == "remainingBalance"
      || this.customSearchForm.value.column.searchDataType.name == "age" || this.customSearchForm.value.column.searchDataType.name == "duration") {
      if (!this.customSearchForm.value.value) {
        this.toastService.addError("Error", "You need to enter a value");
        return;
      }
      if (!Number.isInteger(Number(this.customSearchForm.value.value))) {
        this.toastService.addError("Error", "You need to enter a integer value");
        return;
      }
      searchRule = new SearchRule(
        this.customSearchForm.value.action,
        this.customSearchForm.value.operator,
        this.customSearchForm.value.column,
        this.customSearchForm.value.column.searchDataType,
        null,
        this.customSearchForm.value.value
      );
    } else if (this.customSearchForm.value.column.searchDataType.name == "boolean") {
      if (this.customSearchForm.value.value == null) {
        this.customSearchForm.get("value")!.setValue(true);
      }
      searchRule = new SearchRule(
        this.customSearchForm.value.action,
        new SearchOperator(1, "=", "is equal to"),
        this.customSearchForm.value.column,
        this.customSearchForm.value.column.searchDataType,
        null,
        null,
        null,
        this.customSearchForm.value.value
      );
    } else if (this.customSearchForm.value.column.searchDataType.name == "listElement") {
      searchRule = new SearchRule(
        this.customSearchForm.value.action,
        this.customSearchForm.value.operator,
        this.customSearchForm.value.column,
        this.customSearchForm.value.column.searchDataType,
        null,
        this.customSearchForm.value.value.id
      );
    } else if (this.customSearchForm.value.column.searchDataType.name == "assignedUser") {
      searchRule = new SearchRule(
        this.customSearchForm.value.action,
        new SearchOperator(1, "=", "is equal to"),
        this.customSearchForm.value.column,
        this.customSearchForm.value.column.searchDataType,
        null,
        this.customSearchForm.value.value.id
      );
    }
    this.bookingSearchService.searchRules.push(searchRule!);
    this.bookingSearchService.loading = true;
    let recordsPerPage = this.bookingSearchService.recordsByPage;
    forkJoin({
      bookings: this.httpService.getBookingsCustom(this.bookingSearchService.searchRules, recordsPerPage, 0),
      // bookings: this.httpService.getBookingsCustomTest(this.bookingSearchService.searchRules, 50,0),
      recordNumber: this.httpService.getBookingsCustomRecordNumber(this.bookingSearchService.searchRules)
    }).subscribe(({ bookings, recordNumber }) => {
      this.bookingSearchService.loading = false;
      this.bookingSearchService.bookings = bookings;
      this.bookingSearchService.recordNumber = recordNumber;
      console.log(this.bookingSearchService.searchRules);
      let endMoment = moment();
      this.searchPerformance = endMoment.diff(startMoment) / 1000;
    }, error => {
      this.bookingSearchService.loading = false;
      let apiError = new ApiError(error);
      console.log(apiError);
      this.toastService.addError("Error", "Error: " + apiError.status);
    });
  }

  resetSerchPerformance() {
    this.searchPerformance = null;
  }

  activateSearchEdit(savedSearch: SavedSearch, index: number) {
    this.httpService.getSavedSearchById(savedSearch.id!).subscribe(res => {
      savedSearch = res;
      this.bookingSearchService.savedSearchList[index] = res;
      this.bookingSearchService.savedSearchEditForms[index] = this.builder.group({
        name: savedSearch.name,
        rules: new FormArray([])
      });
      let ruleForms = this.bookingSearchService.savedSearchEditForms[index]!.get("rules") as FormArray;
      for (let rule of savedSearch.searchRules) {
        ruleForms.push(this.builder.group({
          id: rule.id,
          action: rule.searchAction,
          column: rule.searchColumn,
          operator: rule.searchOperator,
          value: [rule.searchColumn.searchDataType.name == "date" ? moment(rule.dateValue).toDate() : rule.strValue, Validators.required]
        }));
      }
    });
  }

  updateSearch(index: number) {
    let savedSearch = this.bookingSearchService.savedSearchList[index];
    let form = this.bookingSearchService.savedSearchEditForms[index];
    savedSearch.name = form!.value.name;
    for (let i = 0; i < savedSearch.searchRules.length; i++) {
      if (savedSearch.searchRules[i].searchColumn.searchDataType.name == "date") {
        savedSearch.searchRules[i].dateValue = moment(form!.value.rules[i].value).utc(true);
      } else {
        savedSearch.searchRules[i].strValue = form!.value.rules[i].value;
      }
    }
    this.httpService.putSavedSearch(savedSearch).subscribe(() => {
      this.toastService.addSuccess("Success", "Success");
    }, error => {
      this.toastService.addError("Error", error.message);
    });
  }

  showCustomForm() {
    console.log(this.customSearchForm);
  }

  downloadPdf(booking: Booking) {
    booking.downloading = true;
    this.httpService.getPdfBlob(booking.id!, booking.student.language.name).subscribe(blob => {
      this.pdfUrl = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = this.pdfUrl;
      link.download = "Vademecum " + booking.student.lastName + " " + booking.student.firstName + ".pdf";
      link.click();
      booking.downloading = false;
    });
  }

  exportWeeklyReport() {
    this.httpService.getWeeklyReportCsv().subscribe(res => {
      let csvBodyStr = res.body;
      let csvEncodedUri = encodeURI("data:text/csv;charset=utf-8," + csvBodyStr);
      let link = document.createElement("a");
      link.href = csvEncodedUri;
      link.download = "Weekly_" + moment().format("DD-MM-YYYY");
      link.click();
    });
  }

  exportMonthlyXlsx() {
    this.startDownload(DownloadType.MONTHLY_XLSX);
    this.httpService.getMonthlyBookingXlsxFile(this.monthlyReportForm.value.month, this.monthlyReportForm.value.year).subscribe(res => {
      let binaryData = [];
      binaryData.push(res);
      this.downloadFile(binaryData, "bookings.xlsx");
      this.stopDownload(DownloadType.MONTHLY_XLSX);
    }, error => {
      this.stopDownload(DownloadType.MONTHLY_XLSX);
      let apiError = new ApiError(error);
      this.toastService.addApiError(apiError);
    });
  }

  exportBookings() {
    if (this.selectedExportOptions == null || this.selectedExportOptions.length == 0) {
      this.showExportWarning();
      return;
    }
    this.startDownload(DownloadType.CUSTOM_CSV);
    let config = new CustomCsvExportConfiguration(this.bookingSearchService.searchRules, this.selectedExportOptions);
    this.httpService.getCustomBookingCsvFile(config).subscribe(res => {
      let csvBodyStr = res;
      let csvEncodedUri = encodeURI("data:text/csv;charset=utf-8," + csvBodyStr);
      let link = document.createElement("a");
      link.href = csvEncodedUri;
      link.download = "bookings.csv";
      link.click();
      this.stopDownload(DownloadType.CUSTOM_CSV);
    }, error => {
      let apiError = new ApiError(error);
      this.toastService.addApiError(apiError);
    });
  }

  showExportWarning() {
    this.toastService.addError("Warning", "You need to choose at least one element to export !");
  }

  exportBookingsXlsx() {
    if (this.selectedExportOptions == null || this.selectedExportOptions.length == 0) {
      this.showExportWarning();
      return;
    }
    this.startDownload(DownloadType.CUSTOM_XLSX);
    let config = new CustomCsvExportConfiguration(this.bookingSearchService.searchRules, this.selectedExportOptions);
    this.httpService.getCustomBookingXlsxFile(config).subscribe(res => {
      let binaryData = [];
      binaryData.push(res);
      this.downloadFile(binaryData, "bookings.xlsx");
      this.stopDownload(DownloadType.CUSTOM_XLSX);
    }, error => {
      this.stopDownload(DownloadType.CUSTOM_XLSX);
      let apiError = new ApiError(error);
      this.toastService.addApiError(apiError);
    });
  }
  startDownload(downloadType: DownloadType) {
    switch (downloadType) {
      case DownloadType.CUSTOM_XLSX:
        this.xlsxDownloadIcon = "pi pi-spin pi-spinner";
        this.exportingXlsx = true;
        break;
      case DownloadType.CUSTOM_CSV:
        this.csvDownloadIcon = "pi pi-spin pi-spinner";
        this.exportingCsv = true;
        break;
      case DownloadType.MONTHLY_XLSX:
        this.monthlyXlsxDownloadIcon = "pi pi-spin pi-spinner";
        this.exportingMonthlyXlsx = true;
        break;
    }
  }

  stopDownload(downloadType: DownloadType) {
    switch (downloadType) {
      case DownloadType.CUSTOM_XLSX:
        this.xlsxDownloadIcon = "pi pi-download";
        this.exportingXlsx = false;
        break;
      case DownloadType.CUSTOM_CSV:
        this.csvDownloadIcon = "pi pi-download";
        this.exportingCsv = false;
        break;
      case DownloadType.MONTHLY_XLSX:
        this.monthlyXlsxDownloadIcon = "pi pi-download";
        this.exportingMonthlyXlsx = false;
        break;
    }
  }

  downloadFile(bytes: BlobPart[], fileName: string) {
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(bytes, { type: 'blob' }));
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  updateDateOffsetOption(option: any) {
    if (option == undefined || option == null) {
      return;
    }
    this.customSearchForm.get("isRelativeDate")!.setValue(true);
    this.customSearchForm.get("dateOffset")!.setValue(null);
  }

  updateFixedDate() {
    this.customSearchForm.get("isRelativeDate")!.setValue(false);
  }

  sortBookings(fieldName: string) {
    let bookings = this.bookingSearchService.bookings;
    switch (fieldName) {
      case "id":
        this.idSortMode *= -1;
        bookings.sort((a, b) => {
          if (a.id < b.id) {
            return -1 * this.idSortMode;
          } if (a.id > b.id) {
            return 1 * this.idSortMode;
          }
          return 0;
        });
        break;
      case "startDate":
        this.startDateSortMode *= -1;
        bookings.sort((a, b) => {
          let start1 = moment(a.startDate);
          let start2 = moment(b.startDate);
          if (start1.isBefore(start2)) {
            return -1 * this.startDateSortMode;
          } if (start1.isAfter(start2)) {
            return 1 * this.startDateSortMode;
          }
          return 0;
        });
        break;
      case "endDate":
        this.endDateSortMode *= -1;
        bookings.sort((a, b) => {
          let end1 = moment(a.endDate);
          let end2 = moment(b.endDate);
          if (end1.isBefore(end2)) {
            return -1 * this.endDateSortMode;
          } if (end1.isAfter(end2)) {
            return 1 * this.startDateSortMode;
          }
          return 0;
        });
        break;
      case "duration":
        this.durationSortMode *= -1;
        bookings.sort((a, b) => {
          if (a.duration < b.duration) {
            return -1 * this.durationSortMode;
          } if (a.duration > b.duration) {
            return 1 * this.durationSortMode;
          }
          return 0;
        });
        break;
      case "school":
        this.schoolSortMode *= -1;
        bookings.sort((a, b) => {
          if (a.school < b.school) {
            return -1 * this.schoolSortMode;
          } if (a.school > b.school) {
            return 1 * this.schoolSortMode;
          }
          return 0;
        });
        break;
      case "course":
        this.courseSortMode *= -1;
        bookings.sort((a, b) => {
          return a.course.localeCompare(b.course) * this.courseSortMode;
        });
        break;
      case "language":
        this.languageSortMode *= -1;
        bookings.sort((a, b) => {
          return a.language.localeCompare(b.language) * this.languageSortMode;
        });
        break;
      case "firstName":
        this.firstNameSortMode *= -1;
        bookings.sort((a, b) => {
          return a.firstName.localeCompare(b.firstName) * this.firstNameSortMode;
        });
        break;
      case "lastName":
        this.lastNameSortMode *= -1;
        bookings.sort((a, b) => {
          return a.lastName.localeCompare(b.lastName) * this.lastNameSortMode;
        });
        break;
      case "dueAmount":
        this.dueAmountSortMode *= -1;
        bookings.sort((a, b) => {
          let amt1 = new Decimal(a.remainingBalanceInEuro);
          let amt2 = new Decimal(b.remainingBalanceInEuro);
          if (amt1.lessThan(amt2)) {
            return -1 * this.dueAmountSortMode;
          }
          if (amt1.greaterThan(amt2)) {
            return 1 * this.dueAmountSortMode;
          }
          return 0;
        });
        break;
      case "totalReceivedInEuro":
        this.totalReceivedSortMode *= -1;
        bookings.sort((a, b) => {
          let amt1 = new Decimal(a.totalReceivedInEuro);
          let amt2 = new Decimal(b.totalReceivedInEuro);
          if (amt1.lessThan(amt2)) {
            return -1 * this.totalReceivedSortMode;
          }
          if (amt1.greaterThan(amt2)) {
            return 1 * this.totalReceivedSortMode;
          }
          return 0;
        });
        break;
      case "active":
        this.activeSortMode *= -1;
        bookings.sort((a, b) => {
          if (!a.active && b.active) {
            return -1 * this.activeSortMode;
          }
          if (a.active && !b.active) {
            return 1 * this.activeSortMode;
          }
          return 0;
        });
        break;
    }
  }

  exportStudentEmails() {
    this.httpService.getStudentEmailListCsv().subscribe(res => {
      let csvBodyStr = res.body;
      let csvEncodedUri = encodeURI("data:text/csv;charset=utf-8," + csvBodyStr);
      let link = document.createElement("a");
      link.href = csvEncodedUri;
      link.download = "Student_email_list_" + moment().format("DD-MM-YYYY");
      link.click();
    });
  }

  exportProductToReport() {
    this.httpService.getProductToReportCsv(this.lastYear).subscribe(res => {
      let csvBodyStr = res.body;
      let csvEncodedUri = encodeURI("data:text/csv;charset=utf-8," + csvBodyStr);
      let link = document.createElement("a");
      link.href = csvEncodedUri;
      link.download = "Product_to_report_" + moment().format("DD-MM-YYYY");
      link.click();
    });
  }
}